import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ReferenceDataService } from '../../../core/services/reference-data.service';
import { ProductionTranslationService } from '../../../core/services/production-translation.service';

/**
 * BANDEAU DE PÉREMPTION DU BUNDLE (#1182 lot 1)
 * =============================================
 *
 * La bascule Hosting est atomique, mais **elle ne recharge pas les onglets déjà
 * ouverts**. Un onglet antérieur à un déploiement exécute l'ancien bundle des
 * heures après, et l'ancien bundle peut se comporter autrement que le site :
 * cas mesuré sur #1179, l'ancien code ne pose pas l'en-tête `Authorization` sur
 * `createInvoice`, donc un code promo à limite personnelle est ignoré et le
 * client est débité **plein tarif**. Il a tapé son code, il ne l'a pas eu.
 *
 * Ce bandeau est le seul moyen de le lui dire.
 *
 * ⚠️ AUCUN RECHARGEMENT AUTOMATIQUE, jamais.
 *
 * Recharger d'autorité détruirait la saisie en cours d'un client au milieu de sa
 * commande — un formulaire d'envoi, c'est une adresse, un destinataire, un
 * contenu. On informe et on propose ; c'est le client qui décide du moment. Le
 * portillon qui BLOQUE réellement une commande faite depuis un bundle périmé est
 * ailleurs, côté serveur : `ordering-gate` dans `createInvoice` (lot 3).
 *
 * ⚠️ NON MASQUABLE, par conception. Un bandeau qu'on ferme est un bandeau qu'on
 * ne revoit pas, et l'onglet reste périmé pour le reste de sa vie.
 */
@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-stale-bundle-banner',
  templateUrl: './stale-bundle-banner.component.html',
  styleUrls: ['./stale-bundle-banner.component.css'],
})
export class StaleBundleBannerComponent implements OnInit, OnDestroy {

  stale = false;
  /** Message d'exploitation, ou '' ⇒ le gabarit sert le texte traduit. */
  operatorMessage = '';

  private sub?: Subscription;

  constructor(
    private refData: ReferenceDataService,
    public translate: ProductionTranslationService,
  ) {}

  ngOnInit(): void {
    // L'écoute temps réel des drapeaux (et non le cache de 30 min) est ce qui
    // permet à un onglet ouvert d'apprendre sa péremption sans être rechargé —
    // or être rechargé est précisément ce qu'on ne peut pas exiger de lui.
    this.sub = this.refData.runtimeFlags().subscribe(() => this.refresh());
    this.refresh();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  reload(): void {
    window.location.reload();
  }

  private refresh(): void {
    this.stale = this.refData.isClientBundleStaleSync();
    this.operatorMessage = this.refData.getBundleStaleMessageSync();
  }
}
